import { getPartyIdParam } from '../../../common/src/hooks/query-params/usePartyId';
import { flowIdDeMotoVerzekering } from '../../../flows/src/constants/flowIds';
import useFlowsInitNew from '../../../flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '../../../flows/src/hooks/useFlowsResetState';
import { setSelectionState } from '../utils/persistUtils';

const useStartDeMotoVerzekeringFlow = (): ((uuid?: string) => void) => {
  const { initFlow } = useFlowsInitNew();
  const { reset } = useFlowsResetState();

  return async (uuid?: string) => {
    const partyId = getPartyIdParam();

    reset();
    const sessionId = await initFlow({
      flowId: flowIdDeMotoVerzekering,
      payload: {
        ...(partyId && { party_id: partyId }),
      },
      inputUrl: partyId
        ? `/product/session?party_id=${partyId}`
        : `/product/session`,
      outputUrl: `/product/session/offers`,
      sessionId: uuid,
    });

    if (sessionId)
      setSelectionState(sessionId, {
        insurance_type: ['two_wheeler'],
      });
  };
};

export default useStartDeMotoVerzekeringFlow;
